import React, { useEffect, useState } from 'react';
import DialogModal from '../../../components/DialogModal';
import { Box, CircularProgress } from '@mui/material';
import DropdownSelect from '../../../components/DropdownSelect';
import { DropdownOption } from '../types';
import { StyledButton } from '../styled';
import { addDeclarationForGrade } from '../../../apis/declarationSetup';

export interface AddDeclarationModalProps {
  open: boolean;
  onClose: () => void;
  grades: DropdownOption[];
  school: string;
  academicYear: string;
  fetchData: () => Promise<void>;
  onApiSuccessAndFailure: (isSuccess: boolean, message: string) => void;
}

const AddDeclarationForGradeModal = ({
  open,
  onClose,
  grades,
  school,
  academicYear,
  fetchData,
  onApiSuccessAndFailure
}: AddDeclarationModalProps) => {
  const [grade, setGrade] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      setGrade('');
    }
  }, [open]);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const body = {
        school,
        grade,
        academicYear,
        declarations: []
      };
      const response = await addDeclarationForGrade(body);
      if (response) {
        await fetchData();
        const message = `Declaration added Successfully`;
        onApiSuccessAndFailure(true, message);
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <DialogModal
        open={open}
        onClose={onClose}
        title='Add Declaration'
        actions={
          <>
            <StyledButton
              onClick={handleSubmit}
              disabled={!grade || isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                'Add'
              )}
            </StyledButton>
          </>
        }
      >
        <Box>
          <DropdownSelect
            sx={{ minWidth: '400px !important' }}
            label='Grade'
            placeholder='Select Grade'
            name='grade'
            value={grade}
            options={grades}
            hasTopLabel
            onChange={(event) => setGrade(event.target.value as string)}
          />
        </Box>
      </DialogModal>
    </>
  );
};

export default AddDeclarationForGradeModal;
